import React from "react";
import { useParams } from "react-router-dom";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import ET3PageDiv from "../../core/et3-page-div";
import Et3PageTitle from "../../core/et3-page-title/index";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import KhattabatClients from "./khattabat-clients";
import getKhattabatFilterStore from "../../stores/khattabat-stores/filter-store";
import { TGender } from "../../Types";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import { getKhattabaAiStore } from "../../stores/khattabat-stores/ai-stores/khattaba-ai-store";
import getKhattabat101CGeneralStore from "../../stores/khattabat-stores/101c-stores/101c-general-store";

const KhatabatClientsMale = withLiteObserverAndTheme(() => {
  const { gender } = useParams();

  React.useEffect(() => {
    const isMale = gender === "Male";
    const pageName = isMale ? `KHATTABAT_M` : `KHATTABAT_F`;
    const subPageName = isMale ? `KHATTABAT_M` : `KHATTABAT_F`;
    const genderAttribute: TGender = isMale ? "m" : "f";
    const { setConversationsClientType, getKhattabaClients } =
      getKhattabat101CGeneralStore();

    getCoreHistoryStore().setPageName(pageName, subPageName);
    const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get();
    if (isAiKhattaba) {
      getKhattabaAiStore().setClients([]);
      return getKhattabaAiStore().setPageGender(genderAttribute);
    }

    setConversationsClientType("PAID");
    getKhattabaClients({
      gender: genderAttribute,
      pageName: pageName
    });
    getKhattabatFilterStore().resetFilters();
  }, [gender]);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{ position: "relative" }}
    >
      <Et3PageTitle
        title={i18n.get("KHATTABAT")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <KhattabatClients />
    </ET3PageDiv>
  );
});
export default KhatabatClientsMale;
